import Link from '@eduzz/houston-ui/Link';
import { QRCodeSVG } from 'qrcode.react';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import Modal from 'v2/components/Shared/Modal';

import { useStyles } from './styles';

type AppRedirectModalProps = {
  isOpen: boolean;
  setClose: () => void;
};

function AppRedirectModal({ isOpen, setClose }: AppRedirectModalProps) {
  const classes = useStyles();
  const history = useHistory();
  const APP_REDIRECT_URL = 'https://app.eduzz.com/?s=eyJzIjoiQmFua0FjY291bnQiLCJwIjp7ImNyZWF0ZUFjY291bnQiOnRydWV9fQ==';

  const handleGoToAddBankAccount = () => {
    history.push('/producer/profile/add-bank-account');
  };

  const handleRedirectToApp = () => {
    window.open(APP_REDIRECT_URL, '_blank');
    setClose();
  };

  return (
    <Modal
      open={isOpen}
      textTitle='Cadastrar nova conta bancária'
      textReturnButton='Cadastrar pelo site'
      textProceedButton='Cadastrar pelo App'
      setClose={setClose}
      handleProceedClick={handleRedirectToApp}
      handleReturnClick={handleGoToAddBankAccount}
    >
      <div className={classes.container}>
        <div>
          <p className={classes.subtitle}>Cadastre sua nova conta bancária de forma simples e rápida pelo aplicativo Eduzz!</p>
          <p className={classes.text}>
            Agora você pode cadastrar suas contas bancárias <b>com aprovação imediata, sem ter que esperar até uma semana!</b>
          </p>
          <p className={classes.text}>
            Utilize o QR-Code e <b>realize o cadastro pelo App.</b>{' '}
            <Link
              href='https://ajuda.eduzz.com/hc/pt-br/articles/4408955665051-Como-cadastrar-minha-conta-banc%C3%A1ria-no-App-Eduzz-'
              target='_blank'
              rel='noopener noreferrer'
            >
              Saiba mais.
            </Link>
          </p>
        </div>
        <div className={classes.qrcode}>
          <QRCodeSVG value={APP_REDIRECT_URL} />
        </div>
      </div>
    </Modal>
  );
}

export { AppRedirectModal };
